import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const ItineraryItemStyle = styled('div')`
    margin-top: 24px;
    .day-title {
        color: var(--sand-700);
        ${typography.subhead}
        padding: 8px 0;
    }

    @media print {
        .day-title {
            break-inside: avoid;
            page-break-inside: avoid;
            margin-top:24px;
        }
    }
`;
export default ItineraryItemStyle;